import { useAutoneTranslation } from '@autone/translations';

import {
  TailwindSelect,
  TailwindSelectContent,
  TailwindSelectItem,
  TailwindSelectTrigger,
  TailwindSelectValue,
} from '../../../../../tailwind';
import { useAdvancedFiltersContext } from '../AdvancedFilters.context';

interface AdvancedFiltersConditionCombineModeProps {
  rowIdx: number;
}

export const AdvancedFiltersConditionCombineMode = ({
  rowIdx,
}: AdvancedFiltersConditionCombineModeProps) => {
  const { common } = useAutoneTranslation();
  const { state, dispatch } = useAdvancedFiltersContext();
  const { conditionCombineMode } = state;

  if (rowIdx === 0) {
    return common('advanced-filters.where');
  } else if (rowIdx === 1) {
    return (
      <TailwindSelect
        value={conditionCombineMode}
        onValueChange={(val: 'and' | 'or') =>
          dispatch({ type: 'CHANGE_COMBINE_MODE', payload: { condition: val } })
        }
      >
        <TailwindSelectTrigger>
          <TailwindSelectValue />
        </TailwindSelectTrigger>
        <TailwindSelectContent>
          <TailwindSelectItem value="and">
            {common('advanced-filters.and')}
          </TailwindSelectItem>
          <TailwindSelectItem value="or">
            {common('advanced-filters.or')}
          </TailwindSelectItem>
        </TailwindSelectContent>
      </TailwindSelect>
    );
  } else {
    return conditionCombineMode === 'and'
      ? common('advanced-filters.and')
      : common('advanced-filters.or');
  }
};
